<template>
  <div class="about">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="columns is-centered">
          <div class="column is-5-desktop is-half-tablet">
            <h3 class="title">Change Password</h3>
            <div class="box">
              <div v-if="error" class="notification is-danger">
                Sorry, an error occured during password change:
                <br />
                {{errorMsg}}
              </div>
              <div v-if="errorPasswordMatch" class="notification is-danger">
                Passwords don't match. Please check that both fields are equal.
              </div>
              <div
                v-if="attemptSuccess"
                class="notification is-success"
              >Password changed successfully.</div>
              <div v-if="!attemptSuccess">
              <form  @submit.prevent="attemptChangePassword">
                <b-field>
                    <b-input type="password"
                        v-model="password_1"
                        required
                        placeholder="Type your new password"
                        minlength="8"
                        password-reveal
                        validation-message="Please enter a new password at least 8 characters long. The longer, the better.">
                    </b-input>
                </b-field>
                <b-field>
                    <b-input type="password"
                        v-model="password_2"
                        required
                        placeholder="Re-type your new password"
                        minlength="8"
                        password-reveal
                        validation-message="Please enter a new password at least 8 characters long. The longer, the better.">
                    </b-input>
                </b-field>
                <button
                  v-bind:class="{'is-loading': loading}"
                  class="button is-block is-primary  is-fullwidth"
                >Change Password</button>
              </form>
              </div>
            </div>
          </div>
           </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "forgotpassword",
  data: function () {
    return {
      error: false,
      errorMsg: "",
      attemptSuccess: false,
      password_1: null,
      password_2: null,
      loading: false,
      errorPasswordMatch: false
    };
  },
  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.$router.push("/login");
      return
    }
  },
  computed: {
    ...mapState(["user", "account"]),
  },
  methods: {
    attemptChangePassword: function () {
      this.error = false;
      this.errorPasswordMatch = false

      if(this.password_1 !== this.password_2) {
        this.errorPasswordMatch = true
        return
      }

      this.loading = true;
      this.$store.dispatch('changePassword', this.password_1).then(() => {
          this.attemptSuccess=true
          this.loading= false;
          this.password_1 = null
          this.password_2 = null
        })
        .catch(error => {
          console.log("It's an error", error);
          this.loading= false;
          this.error = true;
          if (error.responseText.trim() == "ERROR_INVALID_PASSWORD") {
            this.errorMsg = "Password must be at least 8 characters long.";
          } else {
            this.errorMsg = "OMG, something went wrong. It was us, not you and the team was already notified. Please try again later."
          }
          
        });
    }
  },
};
</script>

